import { createAction } from 'redux-actions';

export const LOAD_META_DATA_DESCRIPTOR = 'LOAD_META_DATA_DESCRIPTOR';
export const LOAD_META_DATA_DESCRIPTOR_COMPLETE = 'LOAD_META_DATA_DESCRIPTOR_COMPLETE';
export const LOAD_META_DATA_DESCRIPTOR_CANCELLED = 'LOAD_META_DATA_DESCRIPTOR_CANCELLED';
export const LOAD_META_DATA_DESCRIPTOR_FAILURE = 'LOAD_META_DATA_DESCRIPTOR_FAILURE';
export const LOAD_META_ATTRIBUTES = 'LOAD_META_ATTRIBUTES';
export const LOAD_META_ATTRIBUTES_COMPLETE = 'LOAD_META_ATTRIBUTES_COMPLETE';
export const LOAD_META_ATTRIBUTES_FAILURE = 'LOAD_META_ATTRIBUTES_FAILURE';

const loadMetadata = createAction(LOAD_META_DATA_DESCRIPTOR);
const loadMetadataComplete = createAction(LOAD_META_DATA_DESCRIPTOR_COMPLETE);
const loadMetadataCancelled = createAction(LOAD_META_DATA_DESCRIPTOR_CANCELLED);
const loadMetadataFailure = createAction(LOAD_META_DATA_DESCRIPTOR_FAILURE);
const loadAttributes = createAction(LOAD_META_ATTRIBUTES);
const loadAttributesComplete = createAction(LOAD_META_ATTRIBUTES_COMPLETE);
const loadAttributesFailure = createAction(LOAD_META_ATTRIBUTES_FAILURE);

export default {
  loadMetadata,
  loadMetadataComplete,
  loadMetadataCancelled,
  loadMetadataFailure,
  loadAttributes,
  loadAttributesComplete,
  loadAttributesFailure,
};
